import { mapState } from 'vuex';

export default {
  props: {
    type: String,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    waiting() {
      return this.type === 'waiting';
    },
    past() {
      return this.type === 'completed';
    },
    finalConfirmation() {
      return this.type === 'final-confirmation';
    },
    customerSignature() {
      return this.type === 'customer-signature';
    },
    hasAccountColumn() {
      return (
        (this.user && this.user.is_partner_admin_and_master_account) ||
        this.user.is_company_owner_and_master_account
      );
    },
    ordersGrid() {
      // Column widths auto-distribute (the data columns use `<b-col lg>`, matching
      // the auto-width header columns) so they always sum to 12 — adding the Konto
      // column or the status column can no longer overflow the row and wrap the
      // action button onto a new line. The grid therefore only needs to declare the
      // fixed Konto column width and whether the status column is shown.
      // GID-2614: the status column is rendered for every non-completed view; only
      // the completed/past list omits it.
      return {
        account: { lg: '2' },
        status: !this.past,
      };
    },
  },
};
